// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQTeaser__container","mediaLink":"FAQTeaser__mediaLink","isRow":"FAQTeaser__isRow","secondaryLink":"FAQTeaser__secondaryLink","moreLink":"FAQTeaser__moreLink"};